import { render, staticRenderFns } from "./InternationalPrices.vue?vue&type=template&id=49b2f3be"
import script from "./InternationalPrices.vue?vue&type=script&lang=js"
export * from "./InternationalPrices.vue?vue&type=script&lang=js"
import style0 from "./InternationalPrices.vue?vue&type=style&index=0&id=49b2f3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RoamingChoiceSelector: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/ChoiceSelector.vue').default,RoamingExceptionIsSyria: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/ExceptionIsSyria.vue').default,RoamingExceptionDenmarkToDenmark: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/ExceptionDenmarkToDenmark.vue').default,RoamingPriceTable: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/PriceTable.vue').default,RoamingDefaultView: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/DefaultView.vue').default})
